export const BookListSymbol = Symbol('bookList');
